import { memo, useMemo } from 'react';

import Menu from './components/Menu';
import type { MenuOptions } from './model';
import { MenuOptionsProvider, useMenuStore } from './store';

import type { MenuItem } from '@shared-types/menu.types';

const App = ({ options }: { options: MenuOptions & { items: MenuItem[]; trnItem: MenuItem } }) => {
  const initialState = useMemo(
    () => ({
      items: options.items,
      trnItem: options.trnItem,
    }),
    [options.items, options.trnItem],
  );

  useMenuStore.setState(initialState);

  return (
    <MenuOptionsProvider options={options}>
      <Menu />
    </MenuOptionsProvider>
  );
};

export default memo(App);
